import { Link } from "react-router-dom";
import { articleData } from "@/mocks/articles";

export default function ArticlePreviews() {
  return (
    <section className="relative w-full bg-background-100 py-16 md:py-24 px-4 md:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end gap-6 mb-12">
          <span className="inline-flex items-center px-4 py-1.5 bg-accent-100 text-accent-800 rounded-full text-xs whitespace-nowrap w-fit border border-accent-200/50">
            Artigos SEO
          </span>
          <h2 className="font-heading text-3xl md:text-4xl text-foreground-950 leading-tight max-w-2xl">
            Guias Completos sobre CSSBuy Spreadsheet
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {articleData.map((article) => (
            <Link
              key={article.slug}
              to={`/artigo/${article.slug}`}
              className="group flex flex-col bg-background-50 rounded-2xl overflow-hidden border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
            >
              {/* Article Image */}
              <div className="relative w-full h-48 overflow-hidden">
                <img
                  src={article.image}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-50/30 to-transparent"></div>
              </div>

              {/* Article Content */}
              <div className="flex-1 p-5 flex flex-col">
                <h3 className="font-heading text-base text-foreground-950 mb-2 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors duration-200">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-4 line-clamp-2 flex-1">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-2 text-primary-600 text-xs font-medium">
                  <span className="whitespace-nowrap">Ler artigo</span>
                  <i className="ri-arrow-right-line w-3.5 h-3.5 flex items-center justify-center group-hover:translate-x-1 transition-transform duration-200"></i>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}